import { render, staticRenderFns } from "./ArtWorkListingSummary.vue?vue&type=template&id=ab2028a2&scoped=true&"
import script from "./ArtWorkListingSummary.vue?vue&type=script&lang=js&"
export * from "./ArtWorkListingSummary.vue?vue&type=script&lang=js&"
import style0 from "./ArtWorkListingSummary.vue?vue&type=style&index=0&id=ab2028a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2028a2",
  null
  
)

export default component.exports